import React from 'react';

import Link from 'src/components/Common/Link';
import Picture from 'src/components/Common/Picture';

import afterEffectsPicture from 'src/img/logos/tech/after-effects.png';
import ansiblePicture from 'src/img/logos/tech/ansible.png';
import antdPicture from 'src/img/logos/tech/antd.png';
import apolloPicture from 'src/img/logos/tech/apollo.png';
import astroPicture from 'src/img/logos/tech/astro.png';
import bootstrapPicture from 'src/img/logos/tech/bootstrap.png';
import confluencePicture from 'src/img/logos/tech/confluence.png';
import css3Picture from 'src/img/logos/tech/css3.png';
import cssModulesPicture from 'src/img/logos/tech/cssmodules.png';
import cypressPicture from 'src/img/logos/tech/cypress.png';
import ddevPicture from 'src/img/logos/tech/ddev.png';
import digitalOceanPicture from 'src/img/logos/tech/digital-ocean.png';
import dockerPicture from 'src/img/logos/tech/docker.png';
import docusaurusPicture from 'src/img/logos/tech/docusaurus.png';
import doczPicture from 'src/img/logos/tech/docz.png';
import defaultPicture from 'src/img/logos/tech/dummy.png';
import elasticsearchPicture from 'src/img/logos/tech/elasticsearch.png';
import eslintPicture from 'src/img/logos/tech/eslint.png';
import gatsbyPicture from 'src/img/logos/tech/gatsby.png';
import githubPicture from 'src/img/logos/tech/github.png';
import gitlabPicture from 'src/img/logos/tech/gitlab.png';
import goPicture from 'src/img/logos/tech/go.png';
import googleLighthousePicture from 'src/img/logos/tech/google-lighthouse.png';
import graphqlPicture from 'src/img/logos/tech/graphql.png';
import hasuraPicture from 'src/img/logos/tech/hasura.png';
import html5Picture from 'src/img/logos/tech/html5.png';
import illustratorPicture from 'src/img/logos/tech/illustrator.png';
import jenkinsPicture from 'src/img/logos/tech/jenkins.png';
import jestPicture from 'src/img/logos/tech/jest.png';
import jiraPicture from 'src/img/logos/tech/jira.png';
import jqueryPicture from 'src/img/logos/tech/jquery.png';
import kubernetesPicture from 'src/img/logos/tech/kubernetes.png';
import magentoPicture from 'src/img/logos/tech/magento.png';
import markdownPicture from 'src/img/logos/tech/markdown.png';
import materializePicture from 'src/img/logos/tech/materialize.png';
import mattermostPicture from 'src/img/logos/tech/mattermost.png';
import meilisearchPicture from 'src/img/logos/tech/meili-search.png';
import meltanoPicture from 'src/img/logos/tech/meltano.png';
import metabasePicture from 'src/img/logos/tech/metabase.png';
import minioPicture from 'src/img/logos/tech/minio.png';
import mochaPicture from 'src/img/logos/tech/mocha.png';
import mysqlPicture from 'src/img/logos/tech/mysql.png';
import n8nPicture from 'src/img/logos/tech/n8n.png';
import netdataPicture from 'src/img/logos/tech/netdata.png';
import netlifycmsPicture from 'src/img/logos/tech/netlify-cms.png';
import nodejsPicture from 'src/img/logos/tech/node.png';
import npmPicture from 'src/img/logos/tech/npm.png';
import photoshopPicture from 'src/img/logos/tech/photoshop.png';
import phpPicture from 'src/img/logos/tech/php.png';
import pnpmPicture from 'src/img/logos/tech/pnpm.png';
import postcssPicture from 'src/img/logos/tech/postcss.png';
import postgresqlwhitePicture from 'src/img/logos/tech/postgresql-white.png';
import postgresqlPicture from 'src/img/logos/tech/postgresql.png';
import posthogPicture from 'src/img/logos/tech/posthog.png';
import premierePicture from 'src/img/logos/tech/premiere.png';
import prettierPicture from 'src/img/logos/tech/prettier.png';
import prismaPicture from 'src/img/logos/tech/prisma.png';
import pythonPicture from 'src/img/logos/tech/python.png';
import reactHookFormPicture from 'src/img/logos/tech/react-hook-form.png';
import reactPicture from 'src/img/logos/tech/react.png';
import redwoodPicture from 'src/img/logos/tech/redwood.png';
import relayPicture from 'src/img/logos/tech/relay.png';
import sassPicture from 'src/img/logos/tech/sass.png';
import sentryPicture from 'src/img/logos/tech/sentry.png';
import sequelizePicture from 'src/img/logos/tech/sequelize.png';
import shopifyPicture from 'src/img/logos/tech/shopify.png';
import statamicPicture from 'src/img/logos/tech/statamic-logo-lime.png';
import storybookPicture from 'src/img/logos/tech/storybook.png';
import styledcomponentsPicture from 'src/img/logos/tech/styled-components.png';
import tailwindPicture from 'src/img/logos/tech/tailwind.png';
import terraformPicture from 'src/img/logos/tech/terraform.png';
import typescritpPicture from 'src/img/logos/tech/typescript.png';
import typo3Picture from 'src/img/logos/tech/typo3.png';
import visualStudioCodePicture from 'src/img/logos/tech/visual-studio-code.png';
import vitePicture from 'src/img/logos/tech/vite.png';
import vitestPicture from 'src/img/logos/tech/vitest.png';
import webpackPicture from 'src/img/logos/tech/webpack.png';
import yarnPicture from 'src/img/logos/tech/yarnpkg.png';
import zeitPkgPicture from 'src/img/logos/tech/zeit-pkg.png';
import zendPicture from 'src/img/logos/tech/zend.png';

// TODO: Put Name above each logo in story to identify mismatched pictures.
export const LogoLogoTypeTypeOptions = [
  'after_effects',
  'antdesign',
  'ansible',
  'astro',
  'apollo',
  'bootstrap',
  'confluence',
  'css3',
  'cssmodules',
  'cypress',
  'default',
  'digital_ocean',
  'docker',
  'docusaurus',
  'docz',
  'elasticsearch',
  'eslint',
  'gatsby',
  'github',
  'gitlab',
  'graphql',
  'go',
  'google-lighthouse',
  'hasura',
  'html5',
  'illustrator',
  'jenkins',
  'jest',
  'jira',
  'jquery',
  'kubernetes',
  'magento',
  'markdown',
  'materializecss',
  'mattermost',
  'meilisearch',
  'meltano',
  'metabase',
  'minio',
  'mocha',
  'mysql',
  'n8n',
  'netdata',
  'netlifycms',
  'nodejs',
  'npm',
  'photoshop',
  'php',
  'pnpm',
  'postcss',
  'postgresql_white',
  'postgresql',
  'posthog',
  'premiere',
  'prisma',
  'python',
  'react',
  'react-hook-form',
  'redwood',
  'relay',
  'sass',
  'sentry',
  'sequelize',
  'shopify',
  'statamic',
  'storybook',
  'styled_components',
  'tailwind',
  'terraform',
  'typescript',
  'typo3',
  'visual_studio',
  'vite',
  'vitest',
  'webpack',
  'yarn',
  'zeit-pkg',
  'zend',
];
type LogoLogoTypeType = (typeof LogoLogoTypeTypeOptions)[number];

interface LogoProps {
  /** What to display if picture is not found. */
  alt?: string;
  /** Link the Logo points to. */
  link?: string;
  /** A predefined logo or default/null for custom logo. */
  logoType: LogoLogoTypeType;
  /** Path to custom logo image. */
  picture?: string;
  /** imported image */
  image?: string;
  /** Custom title of the logo and link. */
  title?: string;
}

/** Displays a predefined logo from logotype or a custom one. */
const Logo = ({ alt, image, link, logoType, title, picture }: LogoProps) => {
  let LinkProperties;
  let PictureProperties;
  switch (logoType) {
    case 'after_effects':
      LinkProperties = {
        to: 'https://www.adobe.com/de/products/aftereffects.html',
        targetBlank: true,
        title: 'After Effects',
      };
      PictureProperties = {
        image: afterEffectsPicture,
        alt: 'After Effects',
        title: 'After Effects',
      };
      break;
    case 'ansible':
      LinkProperties = {
        to: 'https://docs.ansible.com/',
        targetBlank: true,
        title: 'Ansible',
      };
      PictureProperties = {
        image: ansiblePicture,
        alt: 'Ansible',
        title: 'Ansible',
      };
      break;
    case 'antdesign':
      LinkProperties = {
        to: 'https://ant.design/',
        targetBlank: true,
        title: 'Antdesign',
      };
      PictureProperties = {
        image: antdPicture,
        alt: 'Antd',
        title: 'Antd',
      };
      break;
    case 'apollo':
      LinkProperties = {
        to: 'https://www.apollographql.com/',
        targetBlank: true,
        title: 'Apollo GraphQL',
      };
      PictureProperties = {
        image: apolloPicture,
        alt: 'Apollo GraphQL',
        title: 'Apollo GraphQL',
      };
      break;
    case 'astro':
      LinkProperties = {
        to: 'https://astro.build/',
        targetBlank: true,
        title: 'Astro',
      };
      PictureProperties = {
        image: astroPicture,
        alt: 'Astro',
        title: 'Astro',
      };
      break;
    case 'bootstrap':
      LinkProperties = {
        to: 'http://getbootstrap.com/',
        targetBlank: true,
        title: 'Bootstrap',
      };
      PictureProperties = {
        image: bootstrapPicture,
        alt: 'Bootstrap',
        title: 'Bootstrap',
      };
      break;
    case 'css3':
      LinkProperties = {
        // to: '',
        targetBlank: true,
        title: 'CSS3',
      };
      PictureProperties = {
        image: css3Picture,
        src: 'logos/tech/css3.png',
        alt: 'CSS3',
        title: 'CSS3',
      };
      break;
    case 'cssmodules':
      LinkProperties = {
        to: 'https://github.com/css-modules',
        targetBlank: true,
        title: 'CSS Modules',
      };
      PictureProperties = {
        image: cssModulesPicture,
        alt: 'CSS Modules',
        title: 'CSS Modules',
      };
      break;
    case 'confluence':
      LinkProperties = {
        to: 'https://de.atlassian.com/software/confluence',
        targetBlank: true,
        title: 'Confluence',
      };
      PictureProperties = {
        image: confluencePicture,
        alt: 'Confluence',
        title: 'Confluence',
      };
      break;
    case 'cypress':
      LinkProperties = {
        to: 'https://www.cypress.io/',
        targetBlank: true,
        title: 'Cypress',
      };
      PictureProperties = {
        image: cypressPicture,
        alt: 'Cypress',
        title: 'Cypress',
      };
      break;
    case 'ddev':
      LinkProperties = {
        to: 'https://ddev.readthedocs.io/',
        targetBlank: true,
        title: 'ddev',
      };
      PictureProperties = {
        image: ddevPicture,
        alt: 'ddev',
        title: 'ddev',
      };
      break;
    case 'digital_ocean':
      LinkProperties = {
        to: 'https://www.digitalocean.com/',
        targetBlank: true,
        title: 'Digital Ocean',
      };
      PictureProperties = {
        image: digitalOceanPicture,
        alt: 'Digital Ocean',
        title: 'Digital Ocean',
      };
      break;
    case 'docker':
      LinkProperties = {
        to: 'https://www.docker.com/',
        targetBlank: true,
        title: 'Docker',
      };
      PictureProperties = {
        image: dockerPicture,
        alt: 'Docker',
        title: 'Docker',
      };
      break;
    case 'docz':
      LinkProperties = {
        to: 'https://www.docz.site/',
        targetBlank: true,
        title: 'Docz',
      };
      PictureProperties = {
        image: doczPicture,
        alt: 'Docz',
        title: 'Docz',
      };
      break;
    case 'docusaurus':
      LinkProperties = {
        to: 'https://docusaurus.io/',
        targetBlank: true,
        title: 'Docusaurus',
      };
      PictureProperties = {
        image: docusaurusPicture,
        alt: 'Docusaurus',
        title: 'Docusaurus',
      };
      break;
    case 'elasticsearch':
      LinkProperties = {
        to: 'https://www.elastic.co/products/elasticsearch',
        targetBlank: true,
        title: 'Elasticsearch',
      };
      PictureProperties = {
        image: elasticsearchPicture,
        alt: 'Elasticsearch',
        title: 'Elasticsearch',
      };
      break;
    case 'eslint':
      LinkProperties = {
        to: 'http://eslint.org/',
        targetBlank: true,
        title: 'ESLint',
      };
      PictureProperties = {
        image: eslintPicture,
        alt: 'ESLint',
        title: 'ESLint',
      };
      break;
    case 'github':
      LinkProperties = {
        to: 'https://github.com/',
        targetBlank: true,
        title: 'Github',
      };
      PictureProperties = {
        image: githubPicture,
        alt: 'Github',
        title: 'Github',
      };
      break;
    case 'go':
      LinkProperties = {
        to: 'https://go.dev/',
        targetBlank: true,
        title: 'go',
      };
      PictureProperties = {
        image: goPicture,
        alt: 'go',
        title: 'go',
      };
      break;
    case 'google_lighthouse':
      LinkProperties = {
        to: 'https://de.wikipedia.org/wiki/Google_Lighthouse',
        targetBlank: true,
        title: 'Lighthouse',
      };
      PictureProperties = {
        image: googleLighthousePicture,
        alt: 'Lighthouse',
        title: 'Lighthouse',
      };
      break;
    case 'hasura':
      LinkProperties = {
        to: 'https://hasura.io/',
        targetBlank: true,
        title: 'Hasura',
      };
      PictureProperties = {
        image: hasuraPicture,
        alt: 'Hasura',
        title: 'Hasura',
      };
      break;
    case 'html5':
      LinkProperties = {
        // to: '',
        targetBlank: true,
        title: 'HTML5',
      };
      PictureProperties = {
        image: html5Picture,
        alt: 'HTML5',
        title: 'HTML5',
      };
      break;
    case 'gatsby':
      LinkProperties = {
        to: 'https://www.gatsbyjs.org',
        targetBlank: true,
        title: 'Gatsby',
      };
      PictureProperties = {
        image: gatsbyPicture,
        alt: 'Gatsby',
        title: 'Gatsby',
      };
      break;
    case 'gitlab':
      LinkProperties = {
        to: 'https://about.gitlab.com/',
        targetBlank: true,
        title: 'Gitlab',
      };
      PictureProperties = {
        image: gitlabPicture,
        alt: 'Gitlab',
        title: 'Gitlab',
      };
      break;
    case 'illustrator':
      LinkProperties = {
        to: 'https://www.adobe.com/de/products/illustrator.html',
        targetBlank: true,
        title: 'Adobe Illustrator',
      };
      PictureProperties = {
        image: illustratorPicture,
        alt: 'Adobe Illustrator',
        title: 'Adobe Illustrator',
      };
      break;
    case 'jenkins':
      LinkProperties = {
        to: 'https://jenkins.io/',
        targetBlank: true,
        title: 'Jenkins',
      };
      PictureProperties = {
        image: jenkinsPicture,
        alt: 'Jenkins',
        title: 'Jenkins',
      };
      break;
    case 'jest':
      LinkProperties = {
        to: 'https://jestjs.io/',
        targetBlank: true,
        title: 'Jest',
      };
      PictureProperties = {
        image: jestPicture,
        alt: 'Jest',
        title: 'Jest',
      };
      break;
    case 'jira':
      LinkProperties = {
        to: 'https://de.atlassian.com/software/jira',
        targetBlank: true,
        title: 'Jira',
      };
      PictureProperties = {
        image: jiraPicture,
        alt: 'Jira',
        title: 'Jira',
      };
      break;
    case 'jquery':
      LinkProperties = {
        to: 'https://jquery.com/',
        targetBlank: true,
        title: 'jQuery',
      };
      PictureProperties = {
        image: jqueryPicture,
        alt: 'jQuery',
        title: 'jQuery',
      };
      break;
    case 'kubernetes':
      LinkProperties = {
        to: 'https://kubernetes.io/',
        targetBlank: true,
        title: 'Kubernetes',
      };
      PictureProperties = {
        image: kubernetesPicture,
        alt: 'Kubernetes',
        title: 'Kubernetes',
      };
      break;
    case 'markdown':
      LinkProperties = {
        to: 'https://www.markdownguide.org/',
        targetBlank: true,
        title: 'Markdown',
      };
      PictureProperties = {
        image: markdownPicture,
        alt: 'Markdown',
        title: 'Markdown',
      };
      break;
    case 'magento':
      LinkProperties = {
        to: 'https://magento.com/',
        targetBlank: true,
        title: 'Magento',
      };
      PictureProperties = {
        image: magentoPicture,
        alt: 'Magento',
        title: 'Magento',
      };
      break;
    case 'materializecss':
      LinkProperties = {
        to: 'http://materializecss.com/',
        targetBlank: true,
        title: 'MaterializeCSS',
      };
      PictureProperties = {
        image: materializePicture,
        alt: 'MaterializeCSS',
        title: 'MaterializeCSS',
      };
      break;
    case 'mattermost':
      LinkProperties = {
        to: 'https://about.mattermost.com/',
        targetBlank: true,
        title: 'Mattermost',
      };
      PictureProperties = {
        image: mattermostPicture,
        alt: 'Mattermost',
        title: 'Mattermost',
      };
      break;
    case 'meilisearch':
      LinkProperties = {
        to: 'https://www.meilisearch.com/',
        targetBlank: true,
        title: 'MeiliSearch',
      };
      PictureProperties = {
        image: meilisearchPicture,
        alt: 'MeiliSearch',
        title: 'MeiliSearch',
      };
      break;
    case 'meltano':
      LinkProperties = {
        to: 'https://meltano.com/',
        targetBlank: true,
        title: 'Meltano',
      };
      PictureProperties = {
        image: meltanoPicture,
        alt: 'Meltano',
        title: 'Meltano',
      };
      break;
    case 'metabase':
      LinkProperties = {
        to: 'https://www.metabase.com/',
        targetBlank: true,
        title: 'Metabase',
      };
      PictureProperties = {
        image: metabasePicture,
        alt: 'Metabase',
        title: 'Metabase',
      };
      break;
    case 'mocha':
      LinkProperties = {
        to: 'https://mochajs.org/',
        targetBlank: true,
        title: 'Mocha JS',
      };
      PictureProperties = {
        image: mochaPicture,
        alt: 'Mocha JS',
        title: 'Mocha JS',
      };
      break;
    case 'minio':
      LinkProperties = {
        to: 'https://min.io/',
        targetBlank: true,
        title: 'min.io',
      };
      PictureProperties = {
        image: minioPicture,
        alt: 'min.io',
        title: 'min.io',
      };
      break;
    case 'mysql':
      LinkProperties = {
        to: 'https://www.mysql.com/de/',
        targetBlank: true,
        title: 'MySQL',
      };
      PictureProperties = {
        image: mysqlPicture,
        alt: 'MySQL',
        title: 'MySQL',
      };
      break;
    case 'n8n':
      LinkProperties = {
        to: 'https://n8n.io/',
        targetBlank: true,
        title: 'n8n',
      };
      PictureProperties = {
        image: n8nPicture,
        alt: 'n8n',
        title: 'n8n',
      };
      break;
    case 'netdata':
      LinkProperties = {
        to: 'https://www.netdata.cloud/',
        targetBlank: true,
        title: 'netdata',
      };
      PictureProperties = {
        image: netdataPicture,
        alt: 'netdata',
        title: 'netdata',
      };
      break;
    case 'netlifycms':
      LinkProperties = {
        to: 'https://www.netlifycms.org/',
        targetBlank: true,
        title: 'Netlify CMS',
      };
      PictureProperties = {
        image: netlifycmsPicture,
        alt: 'Netlify CMS',
        title: 'Netlify CMS',
      };
      break;
    case 'nodejs':
      LinkProperties = {
        to: 'https://nodejs.org/',
        targetBlank: true,
        title: 'NodeJS',
      };
      PictureProperties = {
        image: nodejsPicture,
        alt: 'NodeJS',
        title: 'NodeJS',
      };
      break;
    case 'npm':
      LinkProperties = {
        to: 'https://www.npmjs.com/',
        targetBlank: true,
        title: 'npm',
      };
      PictureProperties = {
        image: npmPicture,
        alt: 'npm',
        title: 'npm',
      };
      break;
    case 'php':
      LinkProperties = {
        to: 'http://php.net/',
        targetBlank: true,
        title: 'PHP',
      };
      PictureProperties = {
        image: phpPicture,
        alt: 'PHP',
        title: 'PHP',
      };
      break;
    case 'photoshop':
      LinkProperties = {
        to: 'https://www.adobe.com/de/products/photoshop.html',
        targetBlank: true,
        title: 'Adobe Photoshop',
      };
      PictureProperties = {
        image: photoshopPicture,
        alt: 'Adobe Photoshop',
        title: 'Adobe Photoshop',
      };
      break;
    case 'postcss':
      LinkProperties = {
        to: 'https://github.com/postcss',
        targetBlank: true,
        title: 'PostCSS',
      };
      PictureProperties = {
        image: postcssPicture,
        alt: 'PostCSS',
        title: 'PostCSS',
      };
      break;
    case 'posthog':
      LinkProperties = {
        to: 'https://posthog.com/',
        targetBlank: true,
        title: 'PostHog',
      };
      PictureProperties = {
        image: posthogPicture,
        alt: 'PostHog',
        title: 'PostHog',
      };
      break;
    case 'postgresql':
      LinkProperties = {
        to: 'https://www.postgresql.org/',
        targetBlank: true,
        title: 'PostgreSQL',
      };
      PictureProperties = {
        image: postgresqlPicture,
        alt: 'PostgreSQL',
        title: 'PostgreSQL',
      };
      break;
    case 'postgresql_white':
      LinkProperties = {
        to: 'https://www.postgresql.org/',
        targetBlank: true,
        title: 'PostgreSQL',
      };
      PictureProperties = {
        image: postgresqlwhitePicture,
        alt: 'PostgreSQL',
        title: 'PostgreSQL',
      };
      break;
    case 'premiere':
      LinkProperties = {
        to: 'https://www.adobe.com/de/products/premiere.html',
        targetBlank: true,
        title: 'Adobe Premiere',
      };
      PictureProperties = {
        image: premierePicture,
        alt: 'Adobe Premiere',
        title: 'Adobe Premiere',
      };
      break;
    case 'python':
      LinkProperties = {
        to: 'https://www.python.org/',
        targetBlank: true,
        title: 'Python',
      };
      PictureProperties = {
        image: pythonPicture,
        alt: 'Python',
        title: 'Python',
      };
      break;
    case 'redwood':
      LinkProperties = {
        to: 'https://redwoodjs.com/',
        targetBlank: true,
        title: 'RedwoodJS',
      };
      PictureProperties = {
        image: redwoodPicture,
        alt: 'RedwoodJS',
        title: 'RedwoodJS',
      };
      break;
    case 'react':
      LinkProperties = {
        to: 'https://facebook.github.io/react/',
        targetBlank: true,
        title: 'React',
      };
      PictureProperties = {
        image: reactPicture,
        alt: 'React',
        title: 'React',
      };
      break;
    case 'react-hook-form':
      LinkProperties = {
        to: 'https://react-hook-form.com/',
        targetBlank: true,
        title: 'React Hookform',
      };
      PictureProperties = {
        image: reactHookFormPicture,
        alt: 'React Hookform',
        title: 'React Hookform',
      };
      break;
    case 'relay':
      LinkProperties = {
        to: 'https://facebook.github.io/relay/',
        targetBlank: true,
        title: 'Relay',
      };
      PictureProperties = {
        image: relayPicture,
        alt: 'Relay',
        title: 'Relay',
      };
      break;
    case 'pnpm':
      LinkProperties = {
        to: 'https://pnpm.io/',
        targetBlank: true,
        title: 'pnpm',
      };
      PictureProperties = {
        image: pnpmPicture,
        alt: 'pnpm',
        title: 'pnpm',
      };
      break;
    case 'prettier':
      LinkProperties = {
        to: 'https://prettier.io/',
        targetBlank: true,
        title: 'Prettier',
      };
      PictureProperties = {
        image: prettierPicture,
        alt: 'Prettier',
        title: 'Prettier',
      };
      break;
    case 'prisma':
      LinkProperties = {
        to: 'https://www.prisma.io/',
        targetBlank: true,
        title: 'Prisma',
      };
      PictureProperties = {
        image: prismaPicture,
        alt: 'Prisma',
        title: 'Prisma',
      };
      break;
    case 'graphql':
      LinkProperties = {
        to: 'http://graphql.org/',
        targetBlank: true,
        title: 'GraphQL',
      };
      PictureProperties = {
        image: graphqlPicture,
        alt: 'GraphQL',
        title: 'GraphQL',
      };
      break;
    case 'sequelize':
      LinkProperties = {
        to: 'http://docs.sequelizejs.com/',
        targetBlank: true,
        title: 'Sequelize',
      };
      PictureProperties = {
        image: sequelizePicture,
        alt: 'Sequelize',
        title: 'Sequelize',
      };
      break;
    case 'sass':
      LinkProperties = {
        to: 'http://sass-lang.com/',
        targetBlank: true,
        title: 'Sass',
      };
      PictureProperties = {
        image: sassPicture,
        alt: 'Sass',
        title: 'Sass',
      };
      break;
    case 'sentry':
      LinkProperties = {
        to: 'https://sentry.io/',
        targetBlank: true,
        title: 'Sentry',
      };
      PictureProperties = {
        image: sentryPicture,
        alt: 'Sentry',
        title: 'Sentry',
      };
      break;
    case 'shopify':
      LinkProperties = {
        to: 'https://www.shopify.com/',
        targetBlank: true,
        title: 'Shopify',
      };
      PictureProperties = {
        image: shopifyPicture,
        alt: 'Shopify',
        title: 'Shopify',
      };
      break;
    case 'styled_components':
      LinkProperties = {
        to: 'https://styled-components.com/',
        targetBlank: true,
        title: 'styled components',
      };
      PictureProperties = {
        image: styledcomponentsPicture,
        alt: 'styled components',
        title: 'styled components',
      };
      break;
    case 'statamic':
      LinkProperties = {
        to: 'https://statamic.com/',
        targetBlank: true,
        title: 'Statamic',
      };
      PictureProperties = {
        image: statamicPicture,
        alt: 'Statamic',
        title: 'Statamic',
      };
      break;
    case 'storybook':
      LinkProperties = {
        to: 'https://storybook.js.org/',
        targetBlank: true,
        title: 'Storybook',
      };
      PictureProperties = {
        image: storybookPicture,
        alt: 'Storybook',
        title: 'Storybook',
      };
      break;
    case 'tailwind':
      LinkProperties = {
        to: 'https://tailwindcss.com/',
        targetBlank: true,
        title: 'Tailwind CSS',
      };
      PictureProperties = {
        image: tailwindPicture,
        alt: 'Tailwind CSS',
        title: 'Tailwind CSS',
      };
      break;
    case 'terraform':
      LinkProperties = {
        to: 'https://developer.hashicorp.com/terraform',
        targetBlank: true,
        title: 'Terraform',
      };
      PictureProperties = {
        image: terraformPicture,
        alt: 'Terraform',
        title: 'Terraform',
      };
      break;
    case 'typescript':
      LinkProperties = {
        to: 'https://www.typescriptlang.org/',
        targetBlank: true,
        title: 'TypeScript',
      };
      PictureProperties = {
        image: typescritpPicture,
        alt: 'TypeScript',
        title: 'TypeScript',
      };
      break;
    case 'typo3':
      LinkProperties = {
        to: 'https://typo3.org/',
        targetBlank: true,
        title: 'TYPO3',
      };
      PictureProperties = {
        image: typo3Picture,
        alt: 'TYPO3',
        title: 'TYPO3',
      };
      break;
    case 'visual_studio':
      LinkProperties = {
        to: 'https://code.visualstudio.com/',
        targetBlank: true,
        title: 'Visual Studio Code',
      };
      PictureProperties = {
        image: visualStudioCodePicture,
        alt: 'Visual Studio Code',
        title: 'Visual Studio Code',
      };
      break;
    case 'vite':
      LinkProperties = {
        to: 'https://vitejs.dev/',
        targetBlank: true,
        title: 'Vite',
      };
      PictureProperties = {
        image: vitePicture,
        alt: 'Vite',
        title: 'Vite',
      };
      break;
    case 'vitest':
      LinkProperties = {
        to: 'https://vitest.dev/',
        targetBlank: true,
        title: 'Vitest',
      };
      PictureProperties = {
        image: vitestPicture,
        alt: 'Vitest',
        title: 'Vitest',
      };
      break;
    case 'webpack':
      LinkProperties = {
        to: 'https://webpack.js.org/',
        targetBlank: true,
        title: 'Webpack',
      };
      PictureProperties = {
        image: webpackPicture,
        alt: 'Webpack',
        title: 'Webpack',
      };
      break;
    case 'yarn':
      LinkProperties = {
        to: 'https://yarnpkg.com/lang/en/',
        targetBlank: true,
        title: 'Yarn PKG',
      };
      PictureProperties = {
        image: yarnPicture,
        alt: 'Yarn',
        title: 'Yarn',
      };
      break;
    case 'zeit-pkg':
      LinkProperties = {
        to: 'https://github.com/zeit/pkg',
        targetBlank: true,
        title: 'Zeit PKG',
      };
      PictureProperties = {
        image: zeitPkgPicture,
        alt: 'Zeit PKG',
        title: 'Zeit PKG',
      };
      break;
    case 'zend':
      LinkProperties = {
        to: 'https://framework.zend.com/',
        targetBlank: true,
        title: 'Zend Framework',
      };
      PictureProperties = {
        image: zendPicture,
        alt: 'Zend Framework',
        title: 'Zend Framework',
      };
      break;
    default:
      LinkProperties = {
        targetBlank: true,
        title,
        to: link,
      };
      PictureProperties = {
        alt,
        src: picture,
        title,
      };
      PictureProperties = image
        ? { image, ...PictureProperties }
        : { src: picture, ...PictureProperties };
  }
  return LinkProperties.to ? (
    <Link {...LinkProperties}>
      <Picture {...PictureProperties} />
    </Link>
  ) : (
    <span>
      <Picture {...PictureProperties} />
    </span>
  );
};

Logo.defaultProps = {
  alt: 'Tech Logo',
  link: null,
  picture: null,
  image: defaultPicture,
  title: 'Tech Logo',
};

export default Logo;
